export const API_BASE_URL = process.env.REACT_APP_API_URL || window.location.origin + '/api/v1';
export const API_BASE_URL_ADMIN = process.env.REACT_APP_API_URL_ADMIN || window.location.origin + '/api/v1/admin';
